
import React, { Component, Fragment } from 'react';
import { Button, DatePicker, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import CpSteps from '../../components/CpSteps';
import CpAddressModal from '../../components/CpAddressModal';
import CpProductInfo from '../../components/CpProductInfo';
import CpLoading from '../../components/CpLoading';
import cpSelected from '../../assets/cp-selected.png';
import send from '../../util/request';
import { dateFormat, amountToString } from '../../util/tool';
import cpLogoImg from '../../assets/cp-logo.png';
import moment from 'moment';
import './style.less';
const { localStorage } = window;

const stepConfig = {
  '1': [
    { name: '我的购物车', status: 2 },
    { name: '核对订单信息', status: 1 },
    { name: '成功提交订单', status: 0 }
  ],
  '2': [
    { name: '我的计划单', status: 2 },
    { name: '核对计划单信息', status: 1 },
    { name: '成功提交计划单', status: 0 }
  ],
};

export default class PlanSubmitOrder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shopList: [],
      addressList: [],
      currentAddress: {},
      otherAddressList: [],
      addressIsFold: true,
      currentSupplierId: 0,
      addressModalVisible: false,
      loading: true,
      submitLock: false,
      abroad_transport_type: undefined,
      domestic_transport_type: undefined
    };

    this.record = {};
    const params = new URLSearchParams(this.props.location.search);
    this.type = +params.get('type');
    this.addressId = +params.get('addressId');
    this.columns = [
      { key: 'product', name: '商品信息', align: 'left' },
      { key: 'unit_amount', name: '单价', align: 'right' },
      { key: 'tax_rate', name: '税率', align: 'right' },
      { key: 'tax_inclusive_price', name: '商品价格(含税)', align: 'right' },
      { key: 'number', name: '数量', align: 'center' },
      { key: 'tax_inclusive_subtotal', name: '小计', align: 'right', color: '#D60505' },
    ];
    this.columnsForPlan = [
      { key: 'product', name: '商品信息', align: 'left' },
      { key: 'number', name: '数量', align: 'right', color: '#D60505' },
    ];
  }
  componentDidMount() {
    try {
      this.requestAddressList();
      this.requestProductList();
    } catch (error) {
      console.log("🚀 ~ file: SubmitOrder.js ~ line 62 ~ SubmitOrder ~ componentDidMount ~ error", error);
    } finally {
      this.setState({ loading: false });
    }
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  requestProductList = () => {
    const dataStr = localStorage.getItem('orderData');
    const data = JSON.parse(dataStr);
    let abroadTransportType = undefined, domesticTransportType = undefined;
    const orderData = Reflect.ownKeys(data).map(item => {
      const { saleId: sale_id, number, unit, pre_sale_goods_id = 0, qoute_id, abroad_transport_type, domestic_transport_type } = data[item] || {};
      abroadTransportType = abroad_transport_type;
      domesticTransportType = domestic_transport_type;
      return { sale_id, number, unit, pre_sale_goods_id, qoute_id };
    });
    this.setState({ abroad_transport_type: abroadTransportType, domestic_transport_type: domesticTransportType });
    send({
      url: '/ipp/order/confirm',
      method: 'POST',
      data: {
        order_data: orderData
      }
    }).then(res => {
      this.setState({
        loading: false
      });
      if (res.data && res.data.code === 0) {
        let array = [];
        let totalCount = 0;
        let totalPrice = 0;
        const data = res.data.data;
        data.forEach(obj => {
          let info = {
            supplierId: obj.supplier_id,
            supplierName: obj.supplier_name,
            arriveTime: obj.hope_arrive_time || '',
            saleList: obj.sale_list
          };
          obj.sale_list.forEach(item => {
            totalCount += item.number;
            totalPrice += Number(item.tax_inclusive_subtotal);
            item.unit_amount = amountToString(item.unit_amount);
            item.tax_inclusive_subtotal = amountToString(item.tax_inclusive_subtotal);
          });
          array.push(info);
        });

        this.setState({
          shopList: array,
          totalCount,
          totalPrice: amountToString(totalPrice),
        });
      }
      else {
        message.error(res.data.msg, 2);
      }
    }).catch((err) => {
      this.setState({
        loading: false
      });
      if (err === 105014 || err === 105022 || err === 410) {
        const timer = setTimeout(() => {
          this.props.history.go(-1);
          clearTimeout(timer);
        }, 1000);
      }
    });
  }

  requestAddressList = () => {
    send({
      url: '/ipp/user-address/select',
      method: 'GET',
    }).then(res => {
      if (res.data && res.data.code === 0) {
        const { list = [] } = res.data.data;
        let data = [];
        list.forEach((item) => {
          data.push({
            ...item,
            id: item.id,
            userId: item.user_id,
            username: item.username,
            phone: item.phone,
            provinceId: item.province_id,
            provinceName: item.province_name,
            areaId: item.area_id,
            areaName: item.area_name,
            cityId: item.city_id,
            cityName: item.city_name,
            address: item.address,
            postalCode: item.postal_code,
            isDefault: item.is_default,
            createTime: item.create_time,
            updateTime: item.update_time,
          });
        });
        const currentAddress = data.find(item => item.id === this.addressId);
        if (currentAddress) {
          this.setState({
            addressList: data,
            currentAddress,
          });
        } else {
          message.error('当前地址不存在，请核对后重试！');
          const timer = setTimeout(() => {
            this.props.history.go(-1);
            clearTimeout(timer);
          }, 1000);
        }

      }
    });
  }

  moreBtnClicked = () => {
    this.setState({
      addressIsFold: !this.state.addressIsFold
    });
  }

  selectAddress = (addressId) => {
    let currentAddress = {};
    let otherAddressList = [];
    this.state.addressList.forEach(obj => {
      if (Number(obj.id) === Number(addressId)) {
        currentAddress = obj;
      } else {
        otherAddressList.push(obj);
      }
    });
    this.setState({
      addressIsFold: true,
      currentAddress,
      otherAddressList
    });
  }

  toSubmitOrder = () => {
    const { currentAddress, shopList, abroad_transport_type, domestic_transport_type } = this.state;
    if (!currentAddress || !currentAddress.id) {
      message.info('请先选择收货地址', 2);
      return;
    }

    let timeCount = 0;
    let orderData = [];
    shopList.forEach(obj => {
      if (obj.arriveTime && obj.arriveTime.length) {
        let today = dateFormat(new Date(), 'yyyy-MM-dd');
        if (new Date(obj.arriveTime).getTime() >= new Date(today).getTime()) {
          timeCount += 1;
        }
      }
      let info = {
        supplier_id: obj.supplierId,
        hope_arrive_time: obj.arriveTime,
      };
      let saleList = [];
      obj.saleList.forEach(p => {
        saleList.push({
          sku_no: p.sku_no,
          number: p.number,
          unit: p.sku_unit,
          sale_id: p.sale_id,
          pre_sale_goods_id: p.pre_sale_goods_id,
          qoute_id: p.qoute_id,
          // abroad_transport_type,
          // domestic_transport_type
        });
      });
      info.sale_list = saleList;
      orderData.push(info);
    });

    if (timeCount < orderData.length) {
      message.info('请先选择到货时间', 2);
      return;
    }

    if (this.state.submitLock) { return; }

    this.setState({
      submitLock: true
    });

    let data = {
      order_data: orderData,
      user_address_id: currentAddress.id,
      delivery_type: 1,
      plan_to_order: 1,
      abroad_transport_type,
      domestic_transport_type
    };
    let url = '';
    if (this.type === 1) {       // 提交采购单
      url = '/ipp/order-purchase/insert';
      data.pay_type = 1; //支付方式：1-线下支付
    } else {  // 提交计划单
      url = '/ipp/order-plan/insert';
    }
    send({
      url,
      method: 'POST',
      data
    }).then(res => {
      this.setState({
        submitLock: false
      });
      if (res.data && res.data.code === 0) {
        this.props.history.push(`/basic/submit/${this.type}/result`);
      } else {
        this.setState({
          submitLock: false
        });
        message.error(res.data.msg, 2);
        this.props.history.push(`/basic/submit/${this.type}/result`);
      }
    }).catch(err => {
      this.setState({
        submitLock: false
      });
    });
  }

  changeTime = (supplierId) => {
    let index = this.state.shopList.findIndex(obj => obj.supplierId === supplierId);
    if (index !== -1) {
      let shopList = this.state.shopList;
      shopList[index].arriveTime = dateFormat(new Date(), 'yyyy-MM-dd');
      this.setState({
        shopList,
        currentSupplierId: supplierId,
        showDatePicker: true
      });
    }
  }

  dateChanged = (moment, date) => {
    this.setState({
      showDatePicker: false
    });
    let index = this.state.shopList.findIndex(obj => obj.supplierId === this.state.currentSupplierId);
    if (index !== -1) {
      let shopList = this.state.shopList;
      shopList[index].arriveTime = date;
      this.setState({
        shopList
      });
    }
  }

  addNewAddress = () => {
    this.setState({
      addressModalVisible: true,
    });
    this.record = {};
  }

  editAddress = () => {
    this.record = this.state.currentAddress;
    this.setState({
      addressModalVisible: true,
    });
  }

  hideModal = () => {
    this.setState({
      addressModalVisible: false
    });
    this.record = {};
  }
  submitModal = () => {
    this.setState({
      addressModalVisible: false
    });
    this.record = {};
    this.requestAddressList();
  }
  toProductDetail = (product) => {
    const { spu_id, supplier_id, norms_id } = product;
    if (!spu_id || !supplier_id || !norms_id) {
      message.info('商品缺少spu_id或norms_id或supplier_id', 2);
      return;
    }
    this.props.history.push('/basic/product/detail/' + spu_id + '/' + supplier_id + '/' + norms_id);
  }
  render() {
    const { shopList, totalCount, totalPrice, addressList, addressIsFold, currentAddress, otherAddressList, showDatePicker, currentSupplierId, addressModalVisible, loading, submitLock } = this.state;

    const type = this.type;
    let stepArray = stepConfig[type];
    let columns = type === 1 ? this.columns : this.columnsForPlan;

    let header = (
      <div className="submit-order-top">
        <img style={{ width: 132, height: 60 }} src={cpLogoImg} alt="" />
        <div className="steps"><CpSteps current={1} steps={stepArray} /></div>
      </div>
    );

    let addressItem = (item) => {
      return (
        (!item || !item.id) ? null : (
          <div>
            <span>{item.username}</span>
            <span style={{ marginLeft: '20px' }}>{item.provinceName + item.cityName + item.areaName + item.address}</span>
            <span style={{ marginLeft: '20px' }}>{item.phone}</span>
          </div>
        )
      );
    };

    function disabledDate(current) {
      return current && current < moment().subtract(1, "days"); //当天之前的不可选，不包括当天
    }

    return (
      <div className="submit-order">
        {loading ? <CpLoading size="large" className="cp-loading" /> : null}
        {header}
        <div className="address-info">
          <div className="address-title">收货信息</div>
          <div className="address-list">
            <div className="left">
              {
                addressList.length <= 0 && (
                  <div className="empty-address">
                    <Button className="empty-address-btn" icon={<PlusOutlined />} onClick={this.addNewAddress}>添加地址</Button>
                  </div>
                )
              }
              {
                addressList.length > 0 && (
                  <Fragment>
                    <div className="default-address">
                      <div className="address-item">
                        {addressItem(currentAddress)}
                        {/* <span className='pointer' onClick={this.editAddress}>编辑</span> */}
                        <img className="cp-selected-icon" src={cpSelected} alt=""></img>
                      </div>
                    </div>
                    {
                      !addressIsFold && (
                        <div className="other-address">
                          {
                            otherAddressList.map((item, index) => {
                              return (
                                <div key={index} className="address-item other" onClick={() => { this.selectAddress(item.id); }}>
                                  {addressItem(item)}
                                </div>
                              );
                            })
                          }
                        </div>
                      )
                    }
                    {/* {

                      addressList.length > 1 && (
                        <Button className="address-more" onClick={this.moreBtnClicked}>
                          {
                            addressIsFold ? '更多地址' : '收起更多地址'
                          }
                          {
                            addressIsFold ? <DownOutlined style={{ marginLeft: '10px' }} /> : <UpOutlined style={{ marginLeft: '10px' }} />
                          }
                        </Button>
                      )
                    } */}
                  </Fragment>
                )
              }
            </div>
            {/* <span className='pointer' onClick={this.addNewAddress}>新增收货地址</span> */}
          </div>
        </div>
        {
          type === 1 && (
            <div className="payway-info">
              <div className="payway-title">支付方式</div>
              <div className="payway-list">
                <div className="payway-item">
                  线下付款
                  <img className="cp-selected-icon" src={cpSelected} alt=""></img>
                </div>
              </div>
            </div>
          )
        }
        <div className="product-info">
          <div className="product-title">送货清单</div>
          <div className="product-list">
            <table className="cp-table">
              <thead>
                <tr>
                  {
                    columns.map((item, index) => {
                      return (
                        <th key={index} style={{ textAlign: item.align }}>
                          {item.name}
                        </th>
                      );
                    })
                  }
                </tr>
              </thead>
              <tbody>
                {
                  shopList.map((item, index) => {
                    return (
                      <Fragment key={index}>
                        <tr>
                          <Fragment>
                            <td colSpan={(columns.length) / 2} className="td-group">
                              供应商：{item.supplierName}
                            </td>
                            <td colSpan={(columns.length) / 2} className="td-group group-item">
                              <span>{type === 1 ? '期望到货时间：' : '期望到货时间：'}</span>
                              {
                                item.arriveTime && item.arriveTime.length && (
                                  <DatePicker
                                    bordered={false}
                                    allowClear={false}
                                    placeholder=""
                                    suffixIcon={false}
                                    disabledDate={disabledDate}
                                    open={showDatePicker && item.supplierId === currentSupplierId}
                                    onChange={this.dateChanged}
                                  />
                                )
                              }
                              <span className='pointer' style={{color: 'blue'}} onClick={() => { this.changeTime(item.supplierId); }}>{item.arriveTime.length ? '修改' : '选择'}</span>
                            </td>
                          </Fragment>
                        </tr>
                        {
                          item.saleList.map((p, idx) => {
                            return (
                              <tr key={idx}>
                                {
                                  columns.map((col, i) => {
                                    if (col.key === 'product') {
                                      return (
                                        <td key={i}>
                                          <div className="p-info">
                                            <CpProductInfo product={p} toProductDetail={() => { this.toProductDetail(p); }} />
                                          </div>
                                        </td>
                                      );
                                    } else if (col.key === 'number') {
                                      return (
                                        <td key={i} style={{ textAlign: col.align, fontWeight: '600', color: col.color }}>
                                          x{p.number}
                                        </td>
                                      );
                                    } else if (type === 1 && (col.key === 'unit_amount' || col.key === 'tax_inclusive_subtotal')) {
                                      return (<td key={i} style={{ textAlign: col.align, fontWeight: '600', color: col.color }}>￥{p[col.key]}</td>);
                                    } else if (col.key === 'tax_rate') {
                                      return (<td key={i} style={{ textAlign: col.align, fontWeight: '600', color: col.color }}>{p[col.key] >= 0 ? (+p[col.key] + '%') : '-'}</td>);
                                    } else if (col.key === 'tax_inclusive_price') {
                                      return (<td key={i} style={{ textAlign: col.align, fontWeight: '600', color: col.color }}>{p.tax_inclusive_price === '-' ? '' : <>￥{amountToString(p.tax_inclusive_price)}</>}</td>);
                                    } else {
                                      return null;
                                    }
                                  })
                                }
                              </tr>
                            );
                          })
                        }
                      </Fragment>
                    );
                  })
                }
              </tbody>
            </table>
          </div>
        </div>
        <div className="total-info">
          <div>共<span className="total-count">{totalCount}件</span>商品<span hidden={type === 2}>，总价：<span className="total-price">￥{totalPrice}</span></span></div>
          <div style={{ color: 'rgba(0,0,0,0.5)' }}>
            {addressItem(currentAddress)}
          </div>
        </div>
        <div className="bottom">
          <Button className={submitLock ? 'submit-button unactive' : 'submit-button'} onClick={this.toSubmitOrder}>{
            type === 1 ? '提交订单' : '提交计划单'
          }</Button>
        </div>
        {
          addressModalVisible && (
            <CpAddressModal
              record={this.record}
              hideModal={this.hideModal}
              submitModal={this.submitModal}>
            </CpAddressModal>
          )
        }
      </div>
    );
  }
}
